module.exports = __webpack_public_path__ + "img/download.98a506c8.svg";